import { useCallback, useState } from 'react';
import { ActivityHttp } from '@/services';

export const useActivityReport = () => {

  const [total, setTotal] = useState<number>(undefined);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState<ActivityReportItemEntity[]>([]);

  const fetchReports = useCallback(async (options: ActivityHttp.FetchActivityLogOptions, load = false) => {
    if (load) {
      setLoading(true);
    }
    return ActivityHttp.fetchActivityLogs(options)
      .then(res => {
        setItems(res.items);
        setTotal(res.total);
      })
      .finally(() => {
        if (load) {
          setLoading(false);
        }
      });
  }, [setItems, setTotal, setLoading]);

  const lazyLoadReports = useCallback(async (options: ActivityHttp.FetchActivityLogOptions) => {
    return ActivityHttp.fetchActivityLogs(options)
      .then(res => setItems(oldItems => [...oldItems, ...res.items]));
  }, [setItems]);

  return { items, loading, fetchReports, lazyLoadReports, total };
};

export default useActivityReport;
